<template>
  <div class="flex flex-col h-full" :class="isMobileOrTablet ? 'justify-between' : 'gap-20'">
    <div>
      <p class="text-lg text-center font-500 mb-10">{{ $t('log_in_slogan_title') }}</p>
      <div>
        <facebook-login />
        <div class="mb-3">
          <nd-google-login @update-error-message="updateErrorMessage" />
        </div>

        <nd-button class="w-full h-10" icon="mail" bordered @click="authStore.changeAuthStep('login')">{{ $t('log_in_email') }}</nd-button>

        <p v-if="ctaText" class="mt-8 text-center">{{ ctaText }}</p>
      </div>
      <nd-alert v-if="errorMessage" type="error" icon="alert" class="mb-2">
        {{ errorMessage }}
      </nd-alert>
    </div>

    <div class="flex flex-col gap-2">
      <nd-button type="primary-text" size="mini" @click="handleOpen">
        {{ $t('login_page_contact_us') }}
      </nd-button>
      <p class="text-sm">
        <trans i18n-key="log_in_agreement_statement" :components="transComponents" />
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import LocaleLink from '@/components/global/locale-link.vue'
import NdGoogleLogin from '@/components/login/nd-google-login.vue'
import FacebookLogin from '@/components/login/facebook-login.vue'
import NdAlert from '@/components/common/nd-alert.vue'

import { QueryStringKeys } from '@/constants/commons'
import { useAuthStore } from '@/store/auth'
import { useAppStore } from '@/store/app'

const route = useRoute()
const { t } = useI18n()
const authStore = useAuthStore()
const appStore = useAppStore()

const { handleOpen } = useCustomerService()

const errorMessage = ref('')

const isMobileOrTablet = computed(() => appStore.isMobile || appStore.isTablet)

const ctaText = computed(() => {
  const ctaOptions = [{ condition: !!route.query[QueryStringKeys.REDIRECT_URL]?.includes('/member/coupons'), text: t('log_in_claim_coupon') }]

  return ctaOptions.find(item => item.condition)?.text ?? ''
})
const transComponents = computed(() => ({
  terms: { tag: LocaleLink, props: { class: 'text-yellow-50', to: { path: '/policy' }, target: '_blank' } },
  policy: { tag: LocaleLink, props: { class: 'text-yellow-50', to: { path: '/privacy' }, target: '_blank' } },
}))

const updateErrorMessage = (message: string) => {
  errorMessage.value = message
}
</script>
